<template>
  <div class="password-change">
    <base-heading :underline="false">{{ $t('userAccount.changePassword.title') }}</base-heading>
    <validation-observer ref="changePassObserver"
                         tag="form"
                         @submit.prevent="validatePasswordForm">
      <div class="form-fields">
        <base-v-input v-model.trim="oldPassword"
                      id="oldPassword"
                      name="oldPassword"
                      ref="oldPassword"
                      :submitted="changePasswordSubmitted"
                      :label="$t('userAccount.changePassword.oldPassword')"
                      variant="white"
                      revealPassword
                      type="password"
                      maxlength="20"
                      rules="required"
                      vid="email">
        </base-v-input>
        <validate-password-dropdown :visible="passwordFieldFocused"
                                    :password="newPassword">
          <base-v-input v-model.trim="newPassword"
                        id="newPassword"
                        name="newPassword"
                        type="password"
                        maxlength="20"
                        variant="white"
                        revealPassword
                        ref="newPassword"
                        vid="newPassword"
                        rules="required|password|confirmPassword:@newPasswordConfirm"
                        :disabled="!oldPassword"
                        :submitted="changePasswordSubmitted"
                        :label="$t('userAccount.changePassword.newPassword')"
                        @focus="passwordFieldFocused = true"
                        @blur="passwordFieldFocused = false"/>
        </validate-password-dropdown>
        <validate-password-dropdown :visible="confirmFieldFocused"
                                    :password="newPasswordConfirm">
          <base-v-input v-model.trim="newPasswordConfirm"
                        id="newPasswordConfirm"
                        name="newPasswordConfirm"
                        type="password"
                        maxlength="20"
                        variant="white"
                        revealPassword
                        ref="newPasswordConfirm"
                        vid="newPasswordConfirm"
                        rules="required|password|confirmPassword:@newPassword"
                        :disabled="!oldPassword"
                        :submitted="changePasswordSubmitted"
                        :label="$t('userAccount.changePassword.newPasswordConfirm')"
                        @focus="confirmFieldFocused = true"
                        @blur="confirmFieldFocused = false"/>
        </validate-password-dropdown>
        <base-button :disabled="!formFilled"
                     :loading="dataLoading"
                     class="submit-password-button"
                     type="submit">
          {{ $t('common.saveChanges') }}
        </base-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import ValidatePasswordDropdown from '@/components/common/validate-password-dropdown'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import resetObjectHandler from '@/mixins/resetObjectHandler'

export default {
  name: 'user-password-change',
  components: { ValidatePasswordDropdown },
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      changePasswordSubmitted: false,
      dataLoading: false,
      passwordFieldFocused: false,
      confirmFieldFocused: false
    }
  },
  mixins: [errorMessageHandler, resetObjectHandler],
  computed: {
    formFilled () {
      return !!this.oldPassword && !!this.newPassword && !!this.newPasswordConfirm
    }
  },
  methods: {
    async validatePasswordForm () {
      this.changePasswordSubmitted = true

      const isFormValid = await this.$refs.changePassObserver.validate()

      if (isFormValid) {
        this.submitNewPassword()
      }
    },
    submitNewPassword () {
      this.dataLoading = true

      const dataToSend = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }

      this.$apiRequest.put('user/password/change', dataToSend)
        .then(response => {
          if (response.status >= 200 && response.status < 400) {
            this.resetData()
            this.dataLoading = false
            this.toast('success', {
              message: this.$t('userAccount.changePassword.passwordChangeSuccess')
            })
          } else {
            this.toast('error', {
              message: this.$t('errors.defaultError')
            })
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
          this.dataLoading = false
        })
    },
    resetData () {
      this.resetObject(this.$data)
      this.$refs.changePassObserver.reset()
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.password-change {
  padding-top: 2rem;

  form {
    width: 100%;
    max-width: 360px;
  }

  .submit-password-button {
    margin-top: 1rem;
  }
}
</style>
